import useProfile from "api/UserResource/useProfile";
import ChangePassword from "./ChangePassword";
import { Container } from "layouts";
import PaddingX from "layouts/PaddingX";
import AccountLayout from "../AccountLayout";

const Passwords = () => {
	const { data: profile, isLoading: isLoadingProfile } = useProfile();

	return (
		<Container>
			<div className="min-h-screen bg-gradient-to-br from-gray-50 to-white">
				<div className="pt-6 pb-12">
					<PaddingX>
						<AccountLayout isLoading={isLoadingProfile} profile={profile?.data}>
							{/* Header Section */}
							<div className="mb-8">
								<h1 className="text-2xl font-semibold mb-2">Password & Security</h1>
								<p className="text-gray-600 leading-relaxed">
									Keep your account secure by updating your password regularly. Use a strong, unique
									password.
								</p>
							</div>

							{/* Password Management */}
							<ChangePassword />
						</AccountLayout>
					</PaddingX>
				</div>
			</div>
		</Container>
	);
};

export default Passwords;
